module.exports = __webpack_public_path__ + "2fab738308034ac47d1344e76937d20c.png";


//////////////////
// WEBPACK FOOTER
// ./images/vipcz/line-vivi.png
// module id = 593
// module chunks = 30